import { useEffect, useState } from "react";
import {
  IoLeafOutline,
  IoBulbOutline,
  IoPeopleOutline,
  IoShieldCheckmarkOutline,
  IoHeartOutline,
} from "react-icons/io5";

import banner1 from "../assets/kinemo.jpeg";
import banner4 from "../assets/ppe.jpg";
import banner3 from "../assets/packaging.jpg";

export default function AboutUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => setReady(true), []);

  if (!ready) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const bridgePoints = [
    "Enhance community nourishment through bio-fortified seeds and diverse interests in superior breeds ensuring sustainability.",
    "Strong partnership with international organizations such as AECF, Harvest-plus, IFPRI, CIAT, and SNV in supporting national development and contributing to national food security solutions.",
    "Offer diverse range of seeds including beans, maize, and legumes for local Markets.",
    "Involvement of contracted farmers to expand production meeting the national seed requirement.",
    "Develop long lasting business relationships with local suppliers of pesticides, feeds, day old chicks, and fertilizers for logistics and supply chain management.",
    "Indigenous technical expertise, innovation, and creativity for provision of novel solutions.",
  ];

  const values = [
    { title: "Customer Focus", desc: "We prioritize customer satisfaction, delivering quality products and exceptional service at affordable prices.", icon: <IoPeopleOutline /> },
    { title: "Integrity", desc: "We operate with transparency, honesty, and ethics in all our interactions and businesses.", icon: <IoShieldCheckmarkOutline /> },
    { title: "Innovation", desc: "We encourage creativity, embracing new ideas and solutions to drive growth in the agricultural sector.", icon: <IoBulbOutline /> },
    { title: "Sustainability", desc: "We promote environmentally responsible practices, ensuring a better future.", icon: <IoLeafOutline /> },
    { title: "Teamwork", desc: "We collaborate, support, and empower our workers and stakeholders to achieve shared goals.", icon: <IoPeopleOutline /> },
    { title: "Social Responsibility", desc: "We believe in being beneficial to the community around us and promote fair labor practice.", icon: <IoHeartOutline /> },
  ];

  return (
    <section
      className="MainBodySection py-5"
      style={{
        background:
          "radial-gradient(circle at 12% 6%, rgba(7, 135, 90, 0.10), transparent 34%), linear-gradient(180deg, #f6fbf8 0%, #ffffff 100%)",
      }}
    >
      <div className="container" style={{ maxWidth: "1140px" }}>
        <div
          className="row g-4 align-items-stretch mb-4 mb-lg-5"
          style={{
            borderRadius: "24px",
            overflow: "hidden",
            background: "#ffffff",
            border: "1px solid rgba(15, 23, 42, 0.08)",
            boxShadow: "0 18px 42px rgba(15, 23, 42, 0.10)",
          }}
        >
          <div className="col-lg-6 p-3">
            <img
              src={banner4}
              alt="Kinemo Agro Seeds and Chemical Traders Co. Ltd"
              style={{ width: "100%", height: "100%", minHeight: "360px", objectFit: "cover", display: "block", borderRadius: "15px" }}
            />
          </div>
          <div className="col-lg-6 d-flex">
            <div className="p-4 p-lg-5 d-flex flex-column justify-content-center">
              <div
                className="font-semi-bold mb-2"
                style={{
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  fontSize: "0.78rem",
                  color: "rgba(7, 135, 90, 0.9)",
                }}
              >
                About Kinemo
              </div>
              <h1 className="font-bold mt-1 mb-3 text-primary">Kinemo Agro Seeds and Chemical Traders Co. Ltd</h1>
              <p className="fs-5 font-semi-bold text-secondary mb-3">Fostering ideas for progress.</p>
              <p className="mb-0 text-muted" style={{ lineHeight: 1.72 }}>
                Welcome to Kinemo Agro Seeds and Chemical Traders Co. Ltd, a prominent agribusiness company
                established in March 2016 and commenced operations in March 2018. We specialize in the
                production and distribution of high-quality seeds, agrochemicals, poultry feeds, and day-old chicks.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4 align-items-center mb-4 mb-lg-5">
          <div className="col-lg-6 p-3">
            <img
              src={banner1}
              alt="Kinemo Agro operations"
              style={{
                width: "100%",
                borderRadius: "22px !important",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 14px 30px rgba(15, 23, 42, 0.10)",
              }}
            />
          </div>
          <div className="col-lg-6">
            <h3 className="font-bold mb-3 text-primary">Introduction</h3>
            <p className="text-muted" style={{ lineHeight: 1.72 }}>
              Our primary focus is on providing small-holder farmers in Tanzania with specially adapted,
              climate-resilient agribusiness products. Since inception, we have served farmers through
              technical agricultural services that include training programs and personalized consultations.
            </p>
            <p className="text-muted mb-0" style={{ lineHeight: 1.72 }}>
              We commercialize large-scale agricultural production, leveraging advanced technology and
              efficient processes to produce high-quality seeds for local and Local Markets and
              maximize yields to meet farmers needs.
            </p>
          </div>
        </div>

        <div className="row g-4 mb-4 mb-lg-5">
          <div className="col-lg-6">
            <div
              className="p-4 p-lg-5 h-100"
              style={{
                borderRadius: "20px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 12px 28px rgba(15, 23, 42, 0.08)",
              }}
            >
              <h4 className="font-bold mb-3 text-primary">Sustainable Large-Scale Agribusiness</h4>
              <p className="text-muted mb-0" style={{ lineHeight: 1.72 }}>
                We combine commercial production with sustainable, GAP practices to protect the
                environment while enhancing nutritional outcomes. Our approach emphasizes innovation through
                precision agriculture technologies, collaboration with trusted poultry technology companies,
                and ongoing research into climate-adaptive seed technologies.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="p-4 p-lg-5 h-100"
              style={{
                borderRadius: "20px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 12px 28px rgba(15, 23, 42, 0.08)",
              }}
            >
              <h4 className="font-bold mb-3 text-primary">Technology-Driven Large-Scale Agriculture</h4>
              <p className="text-muted mb-0" style={{ lineHeight: 1.72 }}>
                Our innovative approaches and precision farming techniques optimize crop yields, reduce waste,
                and enhance efficiency. We recognize the vital role reliable food systems play in ensuring
                individual, community, and national well-being.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-4 mb-lg-5">
          <div className="col-lg-4">
            <div
              className="p-4 h-100"
              style={{
                borderRadius: "18px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.07)",
              }}
            >
              <h4 className="font-bold mb-3 text-primary">Vision Statement</h4>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7 }}>
                To promote the optimal utilization of farm inputs, fostering superior breeds, and empowering
                farmers with knowledge, resulting in a substantial increase in agricultural productivity.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div
              className="p-4 h-100"
              style={{
                borderRadius: "18px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.07)",
              }}
            >
              <h4 className="font-bold mb-3 text-primary">Mission Statement</h4>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7 }}>
                To become a company fostering agricultural prosperity by delivering an inclusive package of
                agricultural inputs and imparting farmers with invaluable agronomic knowledge.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div
              className="p-4 h-100"
              style={{
                borderRadius: "18px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.07)",
              }}
            >
              <h4 className="font-bold mb-3 text-primary">Brand Promise</h4>
              <p className="text-muted mb-0" style={{ lineHeight: 1.7 }}>
                We commit to quality inputs, practical training, and reliable partnerships that help farmers
                grow sustainably and profitably.
              </p>
            </div>
          </div>
        </div>

        <div
          className="row g-4 align-items-center mb-4 mb-lg-5"
          style={{
            borderRadius: "22px",
            overflow: "hidden",
            background: "#0f2e20",
            boxShadow: "0 14px 34px rgba(9, 26, 18, 0.24)",
          }}
        >
          <div className="col-lg-5 p-3">
            <img
              src={banner3}
              alt="Kinemo Agro story"
              style={{ width: "100%", height: "100%", minHeight: "300px", objectFit: "cover", display: "block", borderRadius: "15px" }}
            />
          </div>
          <div className="col-lg-7 text-light p-4 p-lg-5">
            <div className="text-uppercase small text-warning font-semi-bold">Our Story and Timeline</div>
            <h3 className="font-bold mt-2 mb-3">Founded in 2016</h3>
            <p className="mb-2" style={{ lineHeight: 1.72 }}>
              Registered under the United Republic of Tanzania Companies Act 2002, we are driven by innovative
              ideas and a passion for African excellence. We are committed to transforming the agricultural
              landscape in Tanzania and bringing families, farmers, and stakeholders together.
            </p>
            <p className="mb-0" style={{ lineHeight: 1.72 }}>
              Our company provides a unique environment for learning, research, and public service, and we
              continue to expand through partnerships and contracted farmer networks.
            </p>
          </div>
        </div>

        <div className="mb-4 mb-lg-5">
          <h3 className="font-bold mb-3 text-primary">By Bridging the Gap in National Food Security, We:</h3>
          <div className="row g-4">
            {bridgePoints.map((point, idx) => (
              <div key={point} className="col-md-6 col-lg-4">
                <div
                  className="p-4 h-100"
                  style={{
                    borderRadius: "18px",
                    background: "#ffffff",
                    border: "1px solid rgba(15, 23, 42, 0.08)",
                    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.07)",
                  }}
                >
                  <div
                    className="font-bold mb-2"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "rgba(7, 135, 90, 0.12)",
                      color: "var(--primaryColor)",
                      display: "grid",
                      placeItems: "center",
                    }}
                  >
                    {idx + 1}
                  </div>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.7 }}>
                    {point}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="text-center mb-4">
            <h3 className="font-bold mb-2 text-primary">Company Values</h3>
            <p className="text-muted mb-0">The principles that guide our daily work.</p>
          </div>
          <div className="row g-4">
            {values.map((item) => (
              <div key={item.title} className="col-md-6 col-lg-4">
                <div
                  className="p-4 h-100"
                  style={{
                    borderRadius: "18px",
                    background: "#ffffff",
                    border: "1px solid rgba(15, 23, 42, 0.08)",
                    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.07)",
                  }}
                >
                  <div
                    className="mb-2"
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "12px",
                      background: "rgba(7, 135, 90, 0.12)",
                      color: "var(--primaryColor)",
                      display: "grid",
                      placeItems: "center",
                      fontSize: 24,
                    }}
                  >
                    {item.icon}
                  </div>
                  <h5 className="font-bold mb-2 text-primary">{item.title}</h5>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.7 }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
